import createIcon from '../../createIcon';

/**
 * @component @name FormatTextdirectionRToL
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTBWMTVIMTJWNEgxNFYxNUgxNlY0SDE4VjJIMTBDNy43OSAyIDYgMy43OSA2IDZDNiA4LjIxIDcuNzkgMTAgMTAgMTBaTTggMTdWMTRMNCAxOEw4IDIyVjE5SDIwVjE3SDhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatTextdirectionRToL = createIcon('FormatTextdirectionRToL', [
  [
    'path',
    {
      d: 'M10 10V15H12V4H14V15H16V4H18V2H10C7.79 2 6 3.79 6 6C6 8.21 7.79 10 10 10ZM8 17V14L4 18L8 22V19H20V17H8Z',
      key: 'bht5vs',
    },
  ],
]);

export default FormatTextdirectionRToL;
